const ONE_SECOND = 1000;

class Clock {
    constructor() {
        this.clock = null; // interval
        this.currentTime = new Date();
        this.currentTime.toLocaleDateString("pl-PL");
        this.futureTime = 0;
        this.limitTime = 0;
        this.element = document.querySelectorAll('.timer') ?? $('<div/>').addClass('.timer');
    }

    start() {
        this.futureTime = new Date(this.currentTime.getFullYear(), this.currentTime.getMonth(), this.currentTime.getDate(), 13, 15, 0);
        this.futureTime.toLocaleDateString("pl-PL");
        this.limitTime = this.futureTime.getTime() - this.currentTime.getTime();

        this.clock = setInterval(() => {
            this.currentTime = new Date();
            this.limitTime = this.futureTime.getTime() - this.currentTime.getTime();
            if (!this.isStopped()) {
                 this.stop();
            }
            
            this.render();
        }, ONE_SECOND);
    }

    isStopped() {
        return this.limitTime > 0;
    }

    render() {
        this.element.forEach(element => {
            element.textContent = this.formatTime();  
        })
    }

    stop() {
        clearInterval(this.clock);
        if(this.element !== null) {
            $(this.element).closest('.details-line').addClass('d-none');
        }
    }

    static parseSeconds(formattedTime) {
        let [hours, minutes, seconds] = formattedTime.split(':').map(Number);
        return (hours * minutes * 60 * ONE_SECOND) + seconds * ONE_SECOND;
    }

    formatTime() {
        let hours = Math.floor(this.limitTime / ONE_SECOND / 3600);
        let minutes = Math.floor((this.limitTime - (hours * 3600 * ONE_SECOND)) / ONE_SECOND / 60);
        let seconds = Math.floor((this.limitTime - ((hours * 3600 * ONE_SECOND) + (minutes * 60 * ONE_SECOND))) / ONE_SECOND);
        let hoursFormat = hours > 0 ? Intl.NumberFormat('pl-PL').format(hours) + "g" : '';
        let minutesFormat = minutes > 0 ? Intl.NumberFormat('pl-PL').format(minutes) + "m" : '';
        let secondsFormat = Intl.NumberFormat('pl-PL').format(seconds) + "s";
        return `${hoursFormat} ${minutesFormat} ${secondsFormat}`
    }
}

function init(){
    let clock = new Clock();
    clock.start();
}


export {
    Clock,
    init
}